import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
export var urlSourceList = '/api/XOrg/BookMaterial/getsourcelist';
export var urlPartnerSource = '/api/XOrg/BookMaterial/GetPartnerSource';
export var urlSchoolSource = '/api/XOrg/PartnerShareSource/GetSchoolSource';
export var urlGetSourceByTeaId = '/api/XOrg/BookMaterial/GetSourceByTeaId';
export var urlSaveFolder = '/api/XOrg/BookMaterial/saveFolder';
import http from 'lib/http';
export var urldelCourseWare = '/api/XOrg/BookMaterial/delCourseWare';
export var urlupdateCourseWare = '/api/XOrg/BookMaterial/updateCourseWare';
export var urldelallCourseWare = '/api/XOrg/BookMaterial/delallCourseWare';
export var urlmoveFolder = '/api/XOrg/BookMaterial/moveFolder';
export var urlgetFolderId = '/api/XOrg/BookMaterial/getFolderId';
export var urlgetStuList = '/api/XOrg/BookMaterial/getClassStu';
export var urlAddCourseScourse = '/api/XOrg/BookMaterial/AddCourseScourse';
export var urlAddLabels = '/api/XOrg/BookMaterial/addLabels';
export function moveFolder(ids, fId) {
  return http.post(urlmoveFolder, {
    ids: ids,
    fId: fId
  });
}
export function getFolderId(courseId) {
  return http.post(urlgetFolderId, {
    courseId: courseId
  }).then(function (rst) {
    var folder = {};
    var resultFolder = [];

    if (rst.list && rst.list.length) {
      folder = {};
      rst.list.forEach(function (el) {
        // el.NodePath
        if (el.ParentId === '0') {
          folder[el.Id] = folder[el.Id] || {
            id: el.Id,
            children: []
          };
          folder[el.Id]['label'] = el.FolderName;
          resultFolder.push(folder[el.Id]);
        } else {
          if (el.NodePath && el.NodePath.length) {
            var paths = el.NodePath.split('/');
            var pathsLen = paths.length - 1;

            for (var i = 0; i <= pathsLen; i++) {
              var path = paths[i];

              if (i !== pathsLen) {
                folder[path] = folder[path] || {
                  id: path,
                  children: []
                };
              } else {
                folder[path] = folder[path] || {
                  id: el.Id
                };
                folder[path]['label'] = el.FolderName;
                var parent = folder[el.ParentId];

                if (parent && !parent.children) {
                  parent['children'] = [];
                }

                folder[el.ParentId].children.push(folder[path]);
              }

              folder[el.ParentId] = folder[el.ParentId] || {
                id: el.ParentId,
                children: []
              };
            }
          }
        }
      });
    }

    console.log(resultFolder);
    return resultFolder;
  });
}
export function GetPartnerSource(CreatedSchoolId, folderId, page, SchoolCourseId) {
  return http.get(urlPartnerSource, {
    params: {
      CreatedSchoolId: CreatedSchoolId,
      folderId: folderId,
      page: page,
      SchoolCourseId: SchoolCourseId
    }
  });
}
export function GetSchoolSource(folderId, page, SchoolCourseTypeId) {
  return http.get(urlSchoolSource, {
    params: {
      folderId: folderId,
      page: page,
      SchoolCourseTypeId: SchoolCourseTypeId
    }
  });
}
export function GetSourceByTeaId(IsPartner, CourseId, folderId, page, SchoolCourseTypeId) {
  return http.get(urlGetSourceByTeaId, {
    params: {
      IsPartner: IsPartner,
      CourseId: CourseId,
      folderId: folderId,
      page: page,
      SchoolCourseTypeId: SchoolCourseTypeId
    }
  });
}
export function NewGetSourceList(courseId, folderId, type, sort, page, pageSize) {
  return http.get(urlSourceList, {
    params: {
      courseId: courseId,
      folderId: folderId,
      type: type,
      sort: sort,
      page: page,
      pageSize: pageSize
    }
  });
}
export function GetSourceList(courseId, folderId, type, page, pageSize) {
  return http.get(urlSourceList, {
    params: {
      courseId: courseId,
      folderId: folderId,
      type: type,
      page: page,
      pageSize: pageSize
    }
  });
}
export var urlSourceInfo = '/api/XOrg/BookMaterial/getNewCourseWareInfo';
export function GetSourceInfo(coursewareid) {
  return http.get(urlSourceInfo, {
    params: {
      coursewareid: coursewareid
    }
  });
}
export function saveFolder(folderName, courseId, courseName, folderId) {
  return http.post(urlSaveFolder, {
    folderName: folderName,
    courseId: courseId,
    courseName: courseName,
    folderId: folderId
  });
}
export function UpdateCourseWare(id, courseWareName, txtsourceUrl) {
  return http.get(urlupdateCourseWare, {
    params: {
      id: id,
      courseWareName: courseWareName,
      txtsourceUrl: txtsourceUrl
    }
  });
}
export function DelCourseWare(id) {
  return http.post(urldelCourseWare, {
    id: id
  });
}
export function delallCourseWare(ids) {
  return http.post(urldelallCourseWare, {
    ids: ids
  });
}
export function getStuList(classId) {
  return http.post(urlgetStuList, {
    classId: classId
  });
}
export function AddCourseScourse(ids, courseId, folderId, schoolId) {
  return http.post(urlAddCourseScourse, {
    ids: ids,
    courseId: courseId,
    folderId: folderId,
    schoolId: schoolId
  });
}
export function addLabels(id, keyword, mediaType, language, sourceone, author, company, contactInformation) {
  return http.post(urlAddLabels, {
    id: id,
    keyword: keyword,
    mediaType: mediaType,
    language: language,
    sourceone: sourceone,
    author: author,
    company: company,
    contactInformation: contactInformation
  });
}